module.exports = __webpack_public_path__ + "media/images/flags/4x3/ata-303b11d32ac9d07912fc20cf569cab71.svg";